import HttpService from '../baseHttp'

// 系统->平台发运方式列表
// 列表 查看、编辑
export const HttpGetPlatform = (data = {}, config) => HttpService.get('/api/v2/AccountSiteShipping/findByPage', { params: data })
export const HttpQueryPlatform = (data = {}, config) => HttpService.get('/api/v2/AccountSiteShipping/findById', { params: data })
export const HttpSavePlatform = (data = {}, config) => HttpService.post('/api/v2/AccountSiteShipping/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 失效
export const HttpFailurePlatform = (data = {}, config) => HttpService.get('/api/v2/AccountSiteShipping/cancel', { params: data })
// 弹框：平台名称、系统发运方式搜索
export const HttpPlatformName = (data = {}, config) => HttpService.get('/api/v1/ChannelCategory/findByPage', { params: data })
export const HttpPlatformSystem = (data = {}, config) => HttpService.get('/api/v2/SystemDeliveryCarrier/findByPage',{ params:data, baseURL: process.env.VUE_APP_APIURL_FBB})
export const HttpPlatformCarrier = (data = {}, config) => HttpService.get('/api/v2/carrierVolumeWeight/findByFilter',{ params:data, baseURL: process.env.VUE_APP_APIURL_FBB})
// 更换新接口
export const HttpNewPlatformSystem = (data = {}, config) => HttpService.get('/api/v2/sysCarrierService/findAllByPage',{ params:data, baseURL: process.env.VUE_APP_APIURL_SHIP})

// 更换新接口
export const HttpNewPlatformCarrier = (data = {}, config) => HttpService.get('/api/v2/carrierGroupServiceCode/findByFilter',{ params:data, baseURL: process.env.VUE_APP_APIURL_SHIP })


// 系统->仓库发运方式列表
// 列表 查看 编辑
export const HttpGetSysWarehouseCarrier = (data = {}) => HttpService.get("/api/v2/WarehouseCarrierService/findByPage", {params: data,baseURL: process.env.VUE_APP_APIURL_FBB});
export const HttpQuerySysWarehouse = (data = {}) => HttpService.get("/api/v2/WarehouseCarrierService/detail", {params: data,baseURL: process.env.VUE_APP_APIURL_FBB});
export const HttpSaveSysWarehouse = (data = {}, config) => HttpService.post('/api/v2/WarehouseCarrierService/edit', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 失效
export const HttpFailureSysWarehouse = (data = {}, config) => HttpService.post('/api/v2/WarehouseCarrierService/unactive', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 批量失效
export const HttpAllFailureSysWarehouse = (data = {}, config) => HttpService.post('/api/v2/WarehouseCarrierService/batchUnActive', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 生效
export const HttpActiveSysWarehouse = (data = {}, config) => HttpService.post('/api/v2/WarehouseCarrierService/active', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 批量生效
export const HttpAllActiveSysWarehouse = (data = {}, config) => HttpService.post('/api/v2/WarehouseCarrierService/batchActive', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 批量的页面
// 列表搜索
export const HttpGetBatchlist = (data = {}) => HttpService.get("/api/v2/WarehouseCarrierService/findAllCombinations", {params: data,baseURL: process.env.VUE_APP_APIURL_FBB});
// 更新
export const HttpBatchUpdate = (data = {}, config) => HttpService.post('/api/v2/WarehouseCarrierService/batchUpdate', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 全部平台发运方式的获取
export const HttpPlatform = (data, config) => HttpService.get('/api/v2/AccountSiteShipping/findAll', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// 仓库发运方式
// 列表 添加 查看 编辑
export const HttpGetWarehouse = (data = {}) => HttpService.get("/api/v2/OrgWarehouseCarrierService/findByPage", {params: data,baseURL: process.env.VUE_APP_APIURL_FBB});
export const HttpCreateWarehouse = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseCarrierService/create', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpDetailWarehouse = (data = {}) => HttpService.get("/api/v2/OrgWarehouseCarrierService/detail", {params: data,baseURL: process.env.VUE_APP_APIURL_FBB});
export const HttpEditWarehouse = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseCarrierService/edit', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })

// 单条失效
export const HttpSoloFailureWarehouse = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseCarrierService/unactive', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 批量失效
export const HttpFailureWarehouse = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseCarrierService/batchUnActive', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 生效
export const HttpSoloActiveWarehouse = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseCarrierService/active', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 批量生效
export const HttpAllActiveWarehouse = (data = {}, config) => HttpService.post('/api/v2/OrgWarehouseCarrierService/batchActive', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })

// 渠道管理
// 列表
export const HttpGetAccountList = (data = {}, config) => HttpService.get('/api/v1/Account/findByPage', { params: data })
// 创建/编辑 查看
export const HttpSaveAccount = (data = {}, config) => HttpService.post('/api/v1/Account/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpQueryAccount = (data = {}, config) => HttpService.get('/api/v1/Account/findById', { params: data })
// 作废 停用 恢复
export const HttpDelAccount = (data = {}, config) => HttpService.get('/api/v1/Account/del', { params: data })
export const HttpDisableAccount = (data = {}, config) => HttpService.get('/api/v1/Account/cancel', { params: data })
export const HttpActiveAccount = (data = {}, config) => HttpService.get('/api/v1/Account/active', { params: data })
// 
// 渠道发运方式
// 查看 编辑
export const HttpGetAccountShipping = (data = {}, config) => HttpService.get('/api/v2/AccountShipping/findByPage', { params: data })
export const HttpSaveAccountShipping = (data = {}, config) => HttpService.post('/api/v2/AccountShipping/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })

//全部仓库的查看日志
export const HttpAllLogs = (data = {}, config) => HttpService.get('/api/v2/FbbOpLog/findByFilters', { params: data,baseURL: process.env.VUE_APP_APIURL_FBB })
// 

// 添加子账号
// 查询主账号
export const HttpGetaddChild = (data = {}, config) => HttpService.get('/api/v1/Account/findByParent', { params: data })
// 获取账号所在区域国家
export const HttpGetParentCountry = (data = {}, config) => HttpService.get('/api/v1/Account/findByInit', { params: data })
// 保存子账号
export const HttpSaveAccountChild = (data = {}, config) => HttpService.post('/api/v1/Account/save/child', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
// 查询子账号弹框的三个下拉
export const HttpGetTitleAndInit = (data = {}, config) => HttpService.get('/api/v1/Account/findFlagAndTitleAndInit', { params: data })
// 添加广告授权获取的渠道
export const HttpSaveAccountId = (data = {}, config) => HttpService.get('/api/v1/Account/session', { params: data })
// api/v1/Account/session


// 查询vendors类型
export const HttpGetVendorsaddChild = (data = {}, config) => HttpService.get('/api/v1/Account/findByVendor', { params: data })
// vendors下拉
export const HttpGetVendorsTitleAndInit = (data = {}, config) => HttpService.get('/api/v1/Account/findByVendorType', { params: data })



// 编辑渠道渠道仓库全部清除
export const HttpClearAll = (data = {}, config) => HttpService.get('/api/v2/AccountShipping/deleted', { params: data })

// 渠道发货地址维护列表，查看，编辑/保存，删除

export const HttpGetshipmentAddressList = (data = {}, config) => HttpService.get('/api/v2/shipmentAddress/findByPage', { params: data })
export const HttpGetshipmentAddressOne = (data = {}, config) => HttpService.get('/api/v2/shipmentAddress/getById', { params: data })
export const HttpSaveshipmentAddress = (data = {}, config) => HttpService.post('/api/v2/shipmentAddress/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpDeleteshipmentAddressOne = (data = {}, config) => HttpService.get('/api/v2/shipmentAddress/cancel', { params: data })


// 渠道协议及扣点维护
export const HttpGetAgreementList = (data = {}, config) => HttpService.get('/api/v2/AccountAgreement/findByPage', { params: data })
export const HttpGetAgreementOne = (data = {}, config) => HttpService.get('/api/v2/AccountAgreement/findById', { params: data })
export const HttpSaveAgreement = (data = {}, config) => HttpService.post('/api/v2/AccountAgreement/save', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID } })
export const HttpDeleteAgreement = (data = {}, config) => HttpService.get('/api/v2/AccountAgreement/del', { params: data })

// 仓库承运尚带有卡车的物流产品（全部）
export const HttpAllTruckLogProdList = (data = {}) => HttpService.get("/api/v2/carrierGroup/findByCustomerTruck", { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
// 新接口
export const HttpNewAllTruckLogProdList = (data = {}) => HttpService.get("/api/v2/sysCarrierGroup/findByCustomerId", { params: data, baseURL: process.env.VUE_APP_APIURL_SHIP });

// 店铺重新授权
// export const HttpGetAccountInterface = (data = {}) => HttpService.post("/api/v1/Account/getAuthorizeUrl", data, { baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpGetAccountInterface = (data = {}) => HttpService.get("/api/v1/Account/getAuthorizeUrl", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 关联账号详情
export const HttpGetContactAccount = (data = {}) => HttpService.get("/api/v1/Account/findByTitle", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 获取时区
export const HttpGetTimeZone = (data = {}) => HttpService.get("/api/v1/TimeZone/getTimeZone", { params: data });
// 获取国家时区
export const HttpGetTimeZoneByCountry = (data = {}) => HttpService.get("/api/v1/ChannelCategory/findByTypeAndCountry", { params: data });

